import { getData, postData } from "../utils";

// const apiUrlBase = "http://localhost:9000/api";
// const apiUrlBase = "https://dev-mighty-wifi-api.herokuapp.com/api";
const apiUrlBase = "https://mighty-wifi-api.herokuapp.com/api";

const getUserRegisterUrl = () => `${apiUrlBase}/register`;
const getLoginUrl = () => `${apiUrlBase}/login`;
const getRentProductUrl = () => `${apiUrlBase}/product/rent`;

const getProductsByTypeUrl = (type) => `${apiUrlBase}/products/${type}`;
const getProductsByTypeVersionUrl = (type, version) => `${apiUrlBase}/products/${type}/${version}`;

const getAddCartUrl = () => `${apiUrlBase}/add/cart`;
const getCartUrl = () => `${apiUrlBase}/cart`;
const getplaceOrderUrl = () => `${apiUrlBase}/place/order`;
const getordersUrl = () => `${apiUrlBase}/get/orders`;
const getSingleOrderUrl = orderId => `${apiUrlBase}/get/order/${orderId}`;
const getUpdateUserUrl = () => `${apiUrlBase}/update/profile`;
const getUserUrl = () => `${apiUrlBase}/user`;
const getAutoRenewalsUrl = () => `${apiUrlBase}/get/autorenewals`;
const getAutoRenewalDetailUrl = profileId => `${apiUrlBase}/get/autorenewal/${profileId}`;

const getAddShippingUrl = () => `${apiUrlBase}/add/shipping`;
const getAddBillingUrl = () => `${apiUrlBase}/add/billing`;
const getUpdatedShippingUrl = id => `${apiUrlBase}/update/shipping/${id}`;

const getContactUsUrl = () => `${apiUrlBase}/contactus`;
const getUpdatePasswordUrl = () => `${apiUrlBase}/settings/change_password`;
const getForgotPasswordUrl = () => `${apiUrlBase}/forgot_password`;
const getResetPasswordUrl = token => `${apiUrlBase}/reset_password/${token}`;

const getExecutePaypalUrl = () => `${apiUrlBase}/orderExecute`;

const getsubscribeUrl = () => `${apiUrlBase}/subscribe-to-mightywify`;
const getProductByIdUrl = () => `${apiUrlBase}/single/product/`;

const getStoreAddressUrl = () => `${apiUrlBase}/get/store/addresses`;
const getCountriesUrl = () => `${apiUrlBase}/get/countries/`;
const getGlobalCountriesUrl = () => `${apiUrlBase}/get/countries/global/`;
const addActiveSimRequestUrl = () => `${apiUrlBase}/active/sim`;
const addActiveDeviceRequestUrl = () => `${apiUrlBase}/active/device`;
const validateActiveSimCallURL = () => `${apiUrlBase}/find/activeline`;
const getSimDetailsUrl = () => `${apiUrlBase}/find/sim/`;
const validateDeviceIMEIURL = () => `${apiUrlBase}/find/device/`;
const validateDiscountCodeURL = () => `${apiUrlBase}/validate/discount/code`;

const validateSimURL = () => `${apiUrlBase}/validate/sim`;
const validateDeviceURL = () => `${apiUrlBase}/validate/device`;

async function validateSimBySimCardCall(payload){
  const url = validateSimURL();
  return await postData(url, payload)
}

async function validateDeviceCall(payload){
  const url = validateDeviceURL();
  return await postData(url, payload)
}

async function validateDiscountCall(payload){
  const url = validateDiscountCodeURL();
  return await postData(url, payload)
}

async function validateDeviceIMEICall(imei){
  const url = validateDeviceIMEIURL() + imei;
  return await getData(url)
}

async function getSimDetailsCall(number){
  const url = getSimDetailsUrl() + number;
  return await  getData(url);
}

async function validateActiveSimCall(payload){
  const url = validateActiveSimCallURL();
  return await postData(url, payload)
}

async function addActiveSimRequestCall(payload){
    const url = addActiveSimRequestUrl();
    return await postData(url, payload);
}

async function addActiveDeviceRequestCall(payload){
  const url = addActiveDeviceRequestUrl();
  return await postData(url, payload);
}

async function getStoreAddress() {
  const url = getStoreAddressUrl();
  return await getData(url);
}

async function getCountriesCall() {
  const url = getCountriesUrl();
  return await getData(url);
}

async function getGlobalCountriesCall() {
  const url = getGlobalCountriesUrl();
  return await getData(url);
}

async function rentProduct() {
  const url = getRentProductUrl();
  return await getData(url);
}

async function productByID(id) {
    const url = getProductByIdUrl() + id;
    return await  getData(url);
}

async function getProductsByType(type, version = null) {
  const url = version ? getProductsByTypeVersionUrl(type, version) : getProductsByTypeUrl(type);
  return await getData(url);
}

async function getOrdersCall() {
  const url = getordersUrl();
  return await getData(url);
}

async function getSingleOrderCall(orderId) {
  const url = getSingleOrderUrl(orderId);
  return await getData(url);
}

async function getLoggedInUser() {
  const url = getUserUrl();
  return await getData(url);
}

async function getCartCall(reqPayload) {
  const url = getCartUrl();
  return await postData(url, reqPayload);
}

async function getAutoRenewalsCall() {
  const url = getAutoRenewalsUrl();
  return await getData(url);
}

async function getAutoRenewalDetailCall(profileId) {
  const url = getAutoRenewalDetailUrl(profileId);
  return await getData(url);
}

// Post Calls
async function registerUser(reqPayload) {
  const url = getUserRegisterUrl();
  return await postData(url, reqPayload);
}
async function loginUser(reqPayload) {
  const url = getLoginUrl();
  return await postData(url, reqPayload);
}

async function addIntoCart(reqPayload) {
  const url = getAddCartUrl();
  return await postData(url, reqPayload);
}

async function placeOrderCall(reqPayload) {
  const url = getplaceOrderUrl();
  return await postData(url, reqPayload);
}

async function updateUser(reqPayload) {
  const url = getUpdateUserUrl();
  return await postData(url, reqPayload);
}

//Shipping Calls

async function updateShippingRequest(reqPayload) {
  const url = getAddShippingUrl();
  return await postData(url, reqPayload);
}

async function updateBillingRequest(reqPayload) {
  const url = getAddBillingUrl();
  return await postData(url, reqPayload);
}

async function addShippingRequest(reqPayload) {
  const url = getUpdatedShippingUrl();
  return await postData(url, reqPayload);
}

//Contact us call
async function contactUsRequest(reqPayload) {
  const url = getContactUsUrl();
  return await postData(url, reqPayload);
}

async function updatePasswordRequest(reqPayload) {
  const url = getUpdatePasswordUrl();
  return await postData(url, reqPayload);
}

async function forgotPasswordRequest(reqPayload) {
  const url = getForgotPasswordUrl();
  return await postData(url, reqPayload);
}

async function resetPasswordRequest(reqPayload) {
  const url = getResetPasswordUrl(reqPayload.token);
  return await postData(url, reqPayload);
}

async function executePaypalRequest(reqPayload) {
  const url = getExecutePaypalUrl(reqPayload.token);
  return await postData(url, reqPayload);
}

async function mailchimpSubscribeRequest(reqPayload) {
  const url = getsubscribeUrl(reqPayload);
  return await postData(url, reqPayload);
}

export {
    productByID,
  rentProduct,
  registerUser,
  loginUser,
  addIntoCart,
  getCartCall,
  placeOrderCall,
  getOrdersCall,
  getSingleOrderCall,
  getAutoRenewalsCall,
  getAutoRenewalDetailCall,
  updateUser,
  getLoggedInUser,
  updateShippingRequest,
  addShippingRequest,
  contactUsRequest,
  updateBillingRequest,
  updatePasswordRequest,
  forgotPasswordRequest,
  resetPasswordRequest,
  executePaypalRequest,
  mailchimpSubscribeRequest,
  getProductsByType,
  getStoreAddress,
  getCountriesCall,
  getGlobalCountriesCall,
  addActiveSimRequestCall,
  addActiveDeviceRequestCall,
  validateActiveSimCall,
  getSimDetailsCall,
  validateDeviceIMEICall,
  validateDiscountCall,
  validateSimBySimCardCall,
  validateDeviceCall
};



// WEBPACK FOOTER //
// ./src/modules/services/mightyWifiApi.js